import { CONFIG_KEYS, getClientConfigValue } from '../../helpers/config-helper'

export default {
  au: {
    title: 'Westfield Australia',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'Australia',
    lang: 'en-AU',
    url: `https://${getClientConfigValue(CONFIG_KEYS.NEXT_PUBLIC_AU_HOST)}`,
  },
  nz: {
    title: 'Westfield New Zealand',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'New Zealand',
    lang: 'en-NZ',
    url: `https://${getClientConfigValue(CONFIG_KEYS.NEXT_PUBLIC_NZ_HOST)}`,
  },
}
